<template>
    <!-- vue.js will merge class and style attribute -->
    <div class="form-group fix-exclamation" v-if="noWrapper">
        <select class="form-control "
                :class="{'filterSelect2 ignoreValidation': isFilter, 'multiple': multi}"
                ref='input'
                :required="isRequired"
                :disabled="!!disabled"
                :readonly="isReadonly"
                :name="name"
                :id="id"
                v-bind="$attrs"
        ></select>
    </div>
    <np-responsive v-else :split="split">
        <template #label>
        <span>
            {{label}}
            <span
                    v-if="!!helpText"
                    data-bs-placement="right"
                    data-container="body"
                    data-bs-toggle="popover"
                    :title="label"
                    :data-popover-content="helpText"
                    class="np-popover helpBtn addPopover helpHeader">
                <i tabindex="-1" class="fa fa-info-circle"></i>
            </span>
        </span>
        </template>
        <template #input>
        <div class="form-group fix-exclamation">
            <select class="form-control "
                    ref = 'input'
                    :class="{'filterSelect2 ignoreValidation': isFilter, 'multiple': multi}"
                    :required="isRequired"
                    :disabled="!!disabled"
                    :readonly="isReadonly"
                    :name="name"
                    :id="id"
                    v-bind="$attrs"
            ></select>


        </div>
        </template>
    </np-responsive>
</template>

<script>
    import NPResponsive from './np-responsive.vue';
    export default {
        name: 'np-select2-multi',
        props: {
            label: {},
            value: null,
            modelValue:null,
            name: {},
            split: Number,
            check_config: {
                default: true
            },
            default_config: {
                default: false
            },
            mode: {
                type: String,
                default: function () {
                    return 'normal';
                }
            },
            required: false,
            readonly: false,
            fullWidth: false,
            allowClear: {
                default: false
            },
            viewMode: false,
            id: {},
            placeholder: '',
            noWrapper: Boolean,
            parameters: null,
            usePlaceholder:  {
                default: true
            },
            open: false,
            multi: {
                Boolean,
                default: false
            },
            autoselect: false,
            disabled: false,
            helpText: {
                type: String,
                default :'',
            },
            rules: {
                type: Array,
                default: function () {
                    return [];
                }
            },
        },
        components: {
            'np-responsive': NPResponsive,
        },
        data: function () {
            return {
                default_readonly: false,
                select: null,
                disabled_options: {}, // object contains key-value pairs: { id1 : true/false, id2 : false }
                page_config_required: false
            }
        },
        methods: {
            formatSelection: function (state) {
                var vm = this;
                if(vm.mode === 'country') {
                    if (state.iso3) {
                        const country_iso = state.iso3.toLowerCase();
                        var img = '<span> <img class="flag" alt="' + country_iso + '" src="/assets/default/img/flags/' + country_iso.toLowerCase() + '.gif"/> <span> ' + state.text + '</span></span>';
                        return $(img);
                    }
                }
                if(vm.mode === 'phone') {
                    if (state.iso3) {
                        const country_iso = state.iso3.toLowerCase();
                        var img = '<span><span> ' + state.text + '<span> <img class="flag" alt="' + country_iso + '" src="/assets/default/img/flags/' + country_iso.toLowerCase() + '.gif"/> </span>';
                        return $(img);
                    }
                }
                return $('<span>'+state.text+'</span>');
            },
            formatResult: function(state) {
                var vm = this;

                if(vm.mode === 'phone') {
                    if (state.iso3) {
                        const country_iso = state.iso3.toLowerCase();
                        var img = ' <img class="flag" alt="' + country_iso + '" src="/assets/default/img/flags/' + country_iso.toLowerCase() + '.gif"/> '
                            + state.printable_name + ' <span>' + state.text + '</span>';
                        return $(img);
                    }
                }
                return this.formatSelection(state);
            },
            changeValue: function (value) {
                this.modelValue = value;
            },
            assignRules: function () {
                if(this.rules.length > 0) {
                    this.rules.forEach(rule => {
                        if(typeof rule === 'string') {
                            this.select.setAttribute(`${rule}`, '');
                        } else {
                            for (const [key, value] of Object.entries(rule)) {
                                if(typeof value === 'string') {
                                    this.select.setAttribute(`${key}`, `${value}`);
                                } else {
                                    if(value.hasOwnProperty('remove') && value.remove === true && this.select.hasAttribute(key)) {
                                        this.select.removeAttribute(key)
                                    }
                                }
                            }
                        }
                    })
                }
            },
            setRequired: function () {
                var $searchChoices = this.select.parent().find('.select2-choices,.select2-choice');
                if(!!this.isRequired && this.mode !== 'filter') {
                    $searchChoices.addClass('required-field')
                } else {
                    $searchChoices.removeClass('required-field')
                }
            },
            setFullWidth: function () {
                var $searchChoices = $(this.select).parent().find('.select2-choices');
                if(!!this.fullWidth) {
                    $searchChoices.addClass('full-width')
                } else {
                    $searchChoices.removeClass('full-width')
                }
            },
            setSingleParameter: function () {
                let vm = this;
                if (vm.modelValue != vm.parameters[0].id) {
                    vm.$emit('update:modelValue', vm.parameters[0].id);
                    vm.$emit('input', vm.parameters[0].id);
                }
            },
            setValue(val) {
                if (val instanceof Array) {
                    this.select.val([...val]);
                } else {
                    this.select.val([val]);
                }
                this.select.trigger('change');
            },
            init: function () {
                var vm = this;
                let placeholder = (vm.isFilter ? '- ' : `- ${this.lang('select')} `) + (!!vm.placeholder ? vm.placeholder + ' -' : '-');
                let selectConfig = {
                    data: vm.parameters,
                    templateSelection: vm.formatSelection,
                    templateResult: vm.formatResult,
                    multiple: vm.multi,
                    dropdownCss: {'width': 'auto'},
                    width: '100%',
                };
                if(vm.usePlaceholder) {
                    selectConfig['placeholder'] = (vm.isFilter ? '- ' : `- ${this.lang('select')} `) + (!!vm.placeholder ? vm.placeholder + ' -' : '-');
                }
                if(vm.mode === 'filter') {

                    selectConfig['dropdownCss'] = function (data) {return {'font-size': '12px'}};
                    selectConfig['containerCss'] = function (data) {return {'font-size': '12px'}};
                }
                if(vm.mode === 'phone') {
                    selectConfig['matcher'] = function (params, data) {
                        // If there are no search terms, return all of the data
                        if ($.trim(params.term) === '') {
                            return data;
                        }
                        if (data.printable_name.toLowerCase().indexOf(params.term.toLowerCase()) > -1
                            || data.text.indexOf(params.term.toLowerCase()) > -1
                        ) {
                            var modifiedData = $.extend({}, data, true);
                            return modifiedData;
                        }
                        return null;
                    };
                }
                $(this.select).off("select2:select");
                if ($(this.select).hasClass('select2-hidden-accessible')) {
                    $(this.select).select2('destroy');
                }

                if (vm.multi === true) {
                    this.select.prop("multiple", "multiple");
                }
                this.select
                    .select2(selectConfig)
                    .val(vm.modelValue)
                    .trigger('change')
                    // emit event on change.
                    .on('select2:open', function(event) {
                        vm.$emit('open', event)
                    })
                    .on('select2:close', function(event){
                        vm.$emit('close', event)
                    })
                    // .on('select2:unselect', function(event){
                    //     vm.$emit('removed', event.choice);
                    //     // vm.$emit('input', this.value);
                    //     // event.stopPropagation();
                    // })
                    .on('select2:select select2:unselect', function (event) {
                        const { id, text, selected } = event['params']['data'];
                        vm.$emit('update:modelValue', vm.select.val());
                        vm.$emit('input', vm.select.val());

                        if(vm.multi && event.type === 'select2:unselect') {
                            vm.$emit('removed', id);
                        }

                        if(vm.multi && event.type === 'select2:select' && typeof event.params.data !== "undefined") {
                            vm.$emit('added', event.params.data);
                        }
                    });
                vm.setValue(vm.modelValue);

                if(vm.multi){
                    var $parent = this.select.parent();
                    var $searchInput = $parent.find('.select2-input');
                    $searchInput.attr('autocomplete', 'new-password');
                    $searchInput.attr('placeholder', placeholder);
                    if(vm.viewMode) {
                        var $searchField = $parent.find('.select2-search-field');
                        $searchField.addClass('displayNone');
                    }

                    var $select2_container = $parent.find('.select2-container');
                    $select2_container.addClass("np-select2-container-multi");
                }
                if (vm.autoselect && vm.parameters.length == 1) {
                    this.setSingleParameter()
                }
                if(vm.fullWidth) {
                    this.setFullWidth()
                }
                if(!vm.viewMode) {
                    this.setRequired();
                }
                //vm.cleanDisabledOptions();  //prevent some options of new params may unfairly be disabled
            },
            disabledOption: function (option_id) {
                if (!this.multi) {
                    //100 is the limit to anti-attack
                    if (typeof option_id !== undefined && Object.keys(this.disabled_options).length < 100) {
                        this.disabled_options[option_id] = true;
                        //console.log('select2 addDisabledOption', this.id, option_id, this.disabled_options);
                    }
                }
            },
            enableOption: function (option_id) {
                if (!this.multi) {
                    //100 is the limit to anti-attack
                    if (typeof option_id !== undefined && Object.keys(this.disabled_options).length < 100) {
                        this.disabled_options[option_id] = false;
                        //console.log('select2 removeDisabledOption', this.id, option_id, this.disabled_options);
                    }
                }
            },
            cleanDisabledOptions: function () {
                if (!this.multi) {
                    let vm = this;
                    for (let key in vm.disabled_options) {
                        //console.log('clean select2 option', this.id, key, 'disabled=', false);
                        $(this.$refs.input).find('option[value=' + '"' + key + '"]').prop('disabled', false);
                    }
                    Object.keys(vm.disabled_options).forEach(function (key) {
                        delete vm.disabled_options[key];
                    });
                    //console.log('select2 cleanDisabledOptions', this.id, this.disabled_options);
                }
            },
        },
        computed: {
            // select: function() {
            //     return this.$refs.input;
            // },
            isReadonly: function () {
                return this.default_config ? !!this.default_readonly : !!this.readonly;
            },
            isRequired: function () {
                return this.check_config ? !!this.page_config_required : !!this.required;
            },
            isFilter: function() {
                return this.mode === 'filter';
            }
        },
        mounted: function () {
            this.select = $(this.$refs.input);
            this.assignRules();
            this.init();

            this.select.val(this.modelValue).trigger('change');
            this.select.parent('.form-group').removeClass('has-error');
            //
            // $searchInput.prop('autocomplete', 'false');
            // $searchInput.on('focus blur', function() {
            //     $(this).css('width', tableWidth);
            // });
        },
        updated: function () {
            let vm = this;
            if (!this.multi) {
                //disable/enable specific select2 options
                for (let key in vm.disabled_options) {
                    //console.log('update select2 option', this.id, key, 'disabled=', vm.disabled_options[key]);
                    $(this.$refs.input).find('option[value=' + '"' + key + '"]').prop('disabled', vm.disabled_options[key]);
                }
            }
        },
        watch: {
            modelValue: function (value, old_value) {
                // update value
                if (value !== old_value) {
                    this.setValue(value);
                    // this.select.val(value).trigger('change');
                }
            },
            multi: function(value) {

            },
            open: function (isOpen, oldValue) {
                if (isOpen && (isOpen != oldValue)) {
                    this.select.select2('open');
                }
            },
            options: function (options) {
                // update options
                this.select.empty().select2({ data: options })
            },
            isRequired: function (required) {
                let vm = this;
                if (required === false){
                    //remove the has error styling
                    setTimeout(() => {
                        $(vm.select).closest('.form-group').removeClass('has-error')
                    }, 500)
                }
                this.setRequired();
            },
            parameters: function (parameters) {
                // update parameters
                this.select.empty();
                this.parameters = parameters;
                this.init();
            }
        },
        unmounted: function () {
            if ($(this.$el).is("select2")) {
                $(this.$el).off().select2('destroy')
            }
        }
    }
</script>
<!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->

<style>
    .fix-exclamation .select2-container .selection .select2-selection {
        background-color: #FFFFFF !important;
    }
    .fix-exclamation .select2-search input {
        background-color: transparent !important;
    }
</style>

<style scoped>
    .filterSelect2 {
        border: 0 !important;
        padding: 0 !important;
    }
    .filterSelect2 > * {
        height: 30px !important;
    }
</style>
